import React from 'react';
import PropTypes from 'prop-types';
import BookingStatus from 'pages/bookings/show/BookingStatus';

const OrderStatusField = function (props) {
    const {
        record,
    } = props;

    if (!record) {
        return null;
    }

    return <BookingStatus record={ record } />;
};

OrderStatusField.propTypes = {
    record: PropTypes.object,
};

export default OrderStatusField;



// WEBPACK FOOTER //
// ./src/components/field/OrderStatusField.js